/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useContext, useEffect, useState } from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Autocomplete from "@mui/material/Autocomplete";

import { Box, CircularProgress } from "@mui/material";

// @mui material components
import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import Card from "@mui/material/Card";

import ProfileInfoCard from "examples/Cards/InfoCards2/ProfileInfoCard";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDBadgeDot from "components/MDBadgeDot";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DefaultStatisticsCard from "examples/Cards/StatisticsCards/DefaultStatisticsCard";
import DataTable from "examples/Tables/DataTable";

// import dataTableData from "layouts/dashboards/sales/data/dataTableData";
import dataTableData from "layouts/events/event-details/data/dataTableData";
import dataTableData2 from "layouts/events/event-details/data/dataTableData2";

import Header from "layouts/pages/profile/components2/Header";
import PlatformSettings from "layouts/events/event-details/components/PlatformSettings";
import PlatformSettings2 from "layouts/events/event-details/components/PlatformSettings2";

import Divider from "@mui/material/Divider";

import { useParams } from "react-router-dom";
import {
  oneEventStatistiquesApi,
  getEventCategoryProgressionApi,
  getEventCategoryFillRateApi,
} from "api/statistiques";
import { getOneEventApi, downloadOneEventTicketsExcelApi } from "api/events";
import { Key } from "@mui/icons-material";
import FormField from "layouts/applications/wizard/components/FormField";
import { formatedDate } from "utils/formattedDate";
import { formatedTime } from "utils/formattedDate";
import { oneEventStatistiquesCinemaApi } from "api/statistiques";
import { getEventCategoryProgressionCinemaApi } from "api/statistiques";
import { getEventProducerAndReseller } from "api/statistiques";
import { getProducerEventCategoryProgressionApi } from "api/statistiques";
import { AuthContext } from "context/authContext";
import { reduceAvailableTicketsApi, deleteAllAvailableTicketsApi, deleteTicketsBySiegeApi, fixOrphanedTicketsApi, deleteTicketsByTimeIdApi, deleteTicketsNotInTimeIdsApi } from "api/tickets";
import Swal from "sweetalert2";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

function EventsDetails() {
  const [isLoading, setIsLoading] = useState(false);
  const { eventID } = useParams();

  const { userRole } = useContext(AuthContext);

  // DefaultStatisticsCard state for the dropdown value
  const [salesDropdownValue, setSalesDropdownValue] = useState("");

  // DefaultStatisticsCard state for the dropdown action
  const [salesDropdown, setSalesDropdown] = useState(null);

  const [eventStatiquesDetails, setEventStatiquesDetails] = useState(null);

  const [eventDetails, setEventDetails] = useState(null);

  const [categoryProgressionData, setCategoryProgressionData] = useState(null);

  const [categoryFillRateData, setCategoryFillRateData] = useState(null);

  const [availableCinemaHours, setAvailableCinemaHours] = useState([]);
  const [reduceDialogOpen, setReduceDialogOpen] = useState(false);
  const [reduceByValue, setReduceByValue] = useState("");
  const [reduceLoading, setReduceLoading] = useState(false);
  const [selectedReduceCategory, setSelectedReduceCategory] = useState("");
  const [selectedCinemaHour, setSelectedCinemaHour] = useState(null);

  const [deleteBySiegeDialogOpen, setDeleteBySiegeDialogOpen] = useState(false);
  const [deleteBySiegeCategory, setDeleteBySiegeCategory] = useState("");
  const [deleteBySiegeLoading, setDeleteBySiegeLoading] = useState(false);

  const [fixOrphanLoading, setFixOrphanLoading] = useState(false);
  const [exportTicketsLoading, setExportTicketsLoading] = useState(false);

  const [deleteByTimeIdDialogOpen, setDeleteByTimeIdDialogOpen] = useState(false);
  const [deleteByTimeIdList, setDeleteByTimeIdList] = useState([]);
  const [deleteByTimeIdInput, setDeleteByTimeIdInput] = useState("");
  const [deleteByTimeIdLoading, setDeleteByTimeIdLoading] = useState(false);

  const [deleteNotInTimeIdDialogOpen, setDeleteNotInTimeIdDialogOpen] = useState(false);
  const [deleteNotInTimeIdList, setDeleteNotInTimeIdList] = useState([]);
  const [deleteNotInTimeIdInput, setDeleteNotInTimeIdInput] = useState("");
  const [deleteNotInTimeIdLoading, setDeleteNotInTimeIdLoading] = useState(false);

  const [otherRolesDetails, setOtherRoleDetails] = useState(null)
  const [producerCategoryProgressionData, setProducerCategoryProgressionData] = useState(null)
  const [adminCategoryProgressionData, setAdminCategoryProgressionData] = useState(null)
  const [resellerCategoryProgressionData, setResellerCategoryProgressionData] = useState(null)

  const totalCategorySold = categoryProgressionData?.reduce(
    (acc, category) => acc + Number(category.sold || 0),
    0
  );
  const totalCategoryCapacity = categoryProgressionData?.reduce(
    (acc, category) => acc + Number(category.total || 0),
    0
  );
  const totalCategoryProgression =
    totalCategoryCapacity > 0
      ? ((totalCategorySold / totalCategoryCapacity) * 100).toFixed(2)
      : "0.00";

  const totalUsedTickets = categoryFillRateData?.reduce(
    (acc, category) => acc + Number(category.used || 0),
    0
  );
  const totalIssuedTickets = categoryFillRateData?.reduce(
    (acc, category) => acc + Number(category.issued || 0),
    0
  );
  const totalFillRatePercentage =
    totalIssuedTickets > 0
      ? ((totalUsedTickets / totalIssuedTickets) * 100).toFixed(2)
      : "0.00";

  // DefaultStatisticsCard handler for the dropdown action
  const openSalesDropdown = ({ currentTarget }) => setSalesDropdown(currentTarget);
  const closeSalesDropdown = ({ currentTarget }) => {
    setSalesDropdown(null);
    setSalesDropdownValue(currentTarget.innerText || salesDropdownValue);
  };

  useEffect(() => {
    getInitialData();
  }, [selectedCinemaHour]);

  const getInitialData = async () => {
    try {
      setIsLoading(true);

      const allDataObject = {
        generatedId: "#ALL",
        eventDate: "all",
        _id: "52c55423-dbba-4ec7-a0bb-02311671e635L",
      };

      // Fetch event details first so isCinemaMode is based on fresh data, not stale state
      const eventDtails2 = await getOneEventApi(eventID);

      const isCinemaMode =
        (eventDtails2?.isCinema || eventDtails2?.isCirque) &&
        selectedCinemaHour &&
        selectedCinemaHour !== "#ALL";

      const [statsData, progressionData, fillRateData] =
        await Promise.all([
          isCinemaMode
            ? oneEventStatistiquesCinemaApi(eventID, selectedCinemaHour)
            : oneEventStatistiquesApi(eventID),
          isCinemaMode
            ? getEventCategoryProgressionCinemaApi(eventID, selectedCinemaHour)
            : getEventCategoryProgressionApi(eventID),
          getEventCategoryFillRateApi(eventID),
        ]);

      const updatedEventDateList = [allDataObject, ...(eventDtails2?.eventDateList || [])];
      setEventDetails({ ...eventDtails2, eventDateList: updatedEventDateList });
      setAvailableCinemaHours(updatedEventDateList);
      setEventStatiquesDetails(statsData);
      setCategoryProgressionData(progressionData);
      setCategoryFillRateData(fillRateData);

      // Producer/reseller breakdown — fetch separately so failures don't block main stats
      try {
        const otherRolesData = await getEventProducerAndReseller(eventID);
        setOtherRoleDetails(otherRolesData);

        if (otherRolesData?.producerId) {
          const cinemaHour = isCinemaMode ? selectedCinemaHour : null;
          const [producerProg, adminProg, resellerProg] = await Promise.all([
            getProducerEventCategoryProgressionApi(eventID, "Producer", cinemaHour),
            getProducerEventCategoryProgressionApi(eventID, "SuperAdmin", cinemaHour),
            getProducerEventCategoryProgressionApi(eventID, "Revendeur", cinemaHour),
          ]);
          setProducerCategoryProgressionData(producerProg);
          setAdminCategoryProgressionData(adminProg);
          setResellerCategoryProgressionData(resellerProg);
        }
      } catch (producerErr) {
        console.log("Producer/reseller data fetch failed (non-blocking):", producerErr);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  // Dropdown menu template for the DefaultStatisticsCard
  const renderMenu = (state, close) => (
    <Menu
      anchorEl={state}
      transformOrigin={{ vertical: "top", horizontal: "center" }}
      open={Boolean(state)}
      onClose={close}
      keepMounted
      disableAutoFocusItem
    >
      <MenuItem onClick={close}>Last 7 days</MenuItem>
      <MenuItem onClick={close}>Last week</MenuItem>
      <MenuItem onClick={close}>Last 30 days</MenuItem>
    </Menu>
  );

  const handleAutoCompleteCinemaHoursChange = (event, newValue) => {
    try {
      setSelectedCinemaHour(newValue.generatedId);
    } catch (error) {
      console.log("Error", error);
    }
  };

  const handleReduceAvailableTickets = async () => {
    const n = parseInt(reduceByValue);
    if (!n || n < 1) return;
    if (!selectedReduceCategory) {
      Swal.fire("Erreur", "Veuillez sélectionner une catégorie.", "error");
      return;
    }
    try {
      setReduceLoading(true);
      const result = await reduceAvailableTicketsApi(eventID, n, selectedReduceCategory, selectedCinemaHour);
      Swal.fire("Supprimé", result.message, "success");
      setReduceDialogOpen(false);
      setReduceByValue("");
      setSelectedReduceCategory("");
      const updated = await oneEventStatistiquesApi(eventID);
      setEventStatiquesDetails(updated);
    } catch (err) {
      Swal.fire("Erreur", err?.response?.data?.error || "Erreur lors de la suppression.", "error");
    } finally {
      setReduceLoading(false);
    }
  };

  const handleRemoveAllAvailableTickets = async () => {
    const confirm = await Swal.fire({
      title: "Supprimer tous les tickets disponibles ?",
      text: "Tous les tickets avec transactionIsComplet = false seront supprimés pour cet événement.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonText: "Annuler",
      confirmButtonText: "Supprimer tout",
    });
    if (!confirm.isConfirmed) return;
    try {
      setReduceLoading(true);
      const result = await deleteAllAvailableTicketsApi(eventID);
      Swal.fire("Supprimé", result.message, "success");
      const updated = await oneEventStatistiquesApi(eventID);
      setEventStatiquesDetails(updated);
    } catch (err) {
      Swal.fire("Erreur", err?.response?.data?.error || "Erreur lors de la suppression.", "error");
    } finally {
      setReduceLoading(false);
    }
  };

  const handleReduceAllTickets = async () => {
    if (!selectedReduceCategory) {
      Swal.fire("Erreur", "Veuillez sélectionner une catégorie.", "error");
      return;
    }
    const cat = categoryProgressionData?.find((c) => c.id === selectedReduceCategory);
    const availableCount = (cat?.total ?? 0) - (cat?.sold ?? 0);
    if (availableCount <= 0) {
      Swal.fire("Info", "Aucun ticket disponible à supprimer pour cette catégorie.", "info");
      return;
    }
    const confirm = await Swal.fire({
      title: "Supprimer tous les tickets disponibles ?",
      text: `${availableCount} ticket(s) disponibles seront supprimés pour la catégorie "${cat?.name}".`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonText: "Annuler",
      confirmButtonText: "Supprimer tout",
    });
    if (!confirm.isConfirmed) return;
    try {
      setReduceLoading(true);
      const result = await reduceAvailableTicketsApi(eventID, availableCount, selectedReduceCategory, selectedCinemaHour);
      Swal.fire("Supprimé", result.message, "success");
      setReduceDialogOpen(false);
      setReduceByValue("");
      setSelectedReduceCategory("");
      const updated = await oneEventStatistiquesApi(eventID);
      setEventStatiquesDetails(updated);
    } catch (err) {
      Swal.fire("Erreur", err?.response?.data?.error || "Erreur lors de la suppression.", "error");
    } finally {
      setReduceLoading(false);
    }
  };

  const handleDeleteTicketsBySiege = async () => {
    if (!deleteBySiegeCategory) {
      Swal.fire("Erreur", "Veuillez saisir un ticketSiegeId.", "error");
      return;
    }
    const confirm = await Swal.fire({
      title: "Supprimer les tickets de cette catégorie ?",
      text: `Tous les tickets disponibles pour ticketSiegeId "${deleteBySiegeCategory}" seront supprimés. Cette action est irréversible.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonText: "Annuler",
      confirmButtonText: "Supprimer",
    });
    if (!confirm.isConfirmed) return;
    try {
      setDeleteBySiegeLoading(true);
      const result = await deleteTicketsBySiegeApi(eventID, deleteBySiegeCategory);
      Swal.fire("Supprimé", result.message, "success");
      setDeleteBySiegeDialogOpen(false);
      setDeleteBySiegeCategory("");
      const updated = await oneEventStatistiquesApi(eventID);
      setEventStatiquesDetails(updated);
    } catch (err) {
      Swal.fire("Erreur", err?.response?.data?.error || "Erreur lors de la suppression.", "error");
    } finally {
      setDeleteBySiegeLoading(false);
    }
  };

  const handleDeleteTicketsByTimeId = async () => {
    if (deleteByTimeIdList.length === 0) return;
    const confirm = await Swal.fire({
      title: "Supprimer les tickets de ces horaires ?",
      text: `Tous les tickets vendus pour ${deleteByTimeIdList.length} horaire(s) seront supprimés définitivement.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonText: "Annuler",
      confirmButtonText: "Supprimer",
    });
    if (!confirm.isConfirmed) return;
    try {
      setDeleteByTimeIdLoading(true);
      const result = await deleteTicketsByTimeIdApi(eventID, deleteByTimeIdList);
      Swal.fire("Supprimé", result.message, "success");
      setDeleteByTimeIdDialogOpen(false);
      setDeleteByTimeIdList([]);
      setDeleteByTimeIdInput("");
      const updated = await oneEventStatistiquesApi(eventID);
      setEventStatiquesDetails(updated);
    } catch (err) {
      Swal.fire("Erreur", err?.response?.data?.error || "Erreur lors de la suppression.", "error");
    } finally {
      setDeleteByTimeIdLoading(false);
    }
  };

  const handleDeleteTicketsNotInTimeIds = async () => {
    if (deleteNotInTimeIdList.length === 0) return;
    const confirm = await Swal.fire({
      title: "Supprimer les tickets hors horaires valides ?",
      text: `Tous les tickets dont le selectedTimeId N'EST PAS dans la liste (${deleteNotInTimeIdList.length} horaire(s) valide(s)) seront supprimés définitivement.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonText: "Annuler",
      confirmButtonText: "Supprimer",
    });
    if (!confirm.isConfirmed) return;
    try {
      setDeleteNotInTimeIdLoading(true);
      const result = await deleteTicketsNotInTimeIdsApi(eventID, deleteNotInTimeIdList);
      Swal.fire("Supprimé", result.message, "success");
      setDeleteNotInTimeIdDialogOpen(false);
      setDeleteNotInTimeIdList([]);
      setDeleteNotInTimeIdInput("");
      const updated = await oneEventStatistiquesApi(eventID);
      setEventStatiquesDetails(updated);
    } catch (err) {
      Swal.fire("Erreur", err?.response?.data?.error || "Erreur lors de la suppression.", "error");
    } finally {
      setDeleteNotInTimeIdLoading(false);
    }
  };

  const handleFixOrphanedTickets = async () => {
    const confirm = await Swal.fire({
      title: "Corriger les tickets orphelins ?",
      text: `Les tickets disponibles avec un ticketSiegeId invalide${selectedCinemaHour && selectedCinemaHour !== "#ALL" ? " pour cet horaire" : ""} seront supprimés.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonText: "Annuler",
      confirmButtonText: "Corriger",
    });
    if (!confirm.isConfirmed) return;
    try {
      setFixOrphanLoading(true);
      const result = await fixOrphanedTicketsApi(
        eventID,
        selectedCinemaHour && selectedCinemaHour !== "#ALL" ? selectedCinemaHour : null
      );
      Swal.fire("Corrigé", result.message, "success");
      const updated = await oneEventStatistiquesApi(eventID);
      setEventStatiquesDetails(updated);
    } catch (err) {
      Swal.fire("Erreur", err?.response?.data?.error || "Erreur lors de la correction.", "error");
    } finally {
      setFixOrphanLoading(false);
    }
  };

  const handleExportTickets = async () => {
    try {
      setExportTicketsLoading(true);
      const timeId = selectedCinemaHour && selectedCinemaHour !== "#ALL" ? selectedCinemaHour : null;
      const url = await downloadOneEventTicketsExcelApi(eventID, timeId);
      window.open(url, "_blank");
    } catch (err) {
      Swal.fire("Erreur", err?.response?.data?.error || "Erreur lors de l'export.", "error");
    } finally {
      setExportTicketsLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>

        {
          (userRole === "SuperAdmin" || userRole === "Producer") &&
          <>
            <Header
              eventName={`${eventDetails?.eventTitle} ${eventDetails?.isCinema ? "(Cinéma)" : eventDetails?.isCirque ? "(Cirque)" : ""}`}
              image={eventDetails?.images?.eventCoverImg?.url}
              avatarImage={eventDetails?.images?.eventMainImg?.url}
            >
              <MDBox mt={5} mb={3}>
                <Grid container spacing={1}>
                  {/* <Grid item xs={12} md={6} xl={4}>
                    <PlatformSettings />
                  </Grid> */}
                  <Grid item xs={12} md={6} xl={4} sx={{ display: "flex" }}>
                    <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
                    <ProfileInfoCard
                      eventId={eventID}
                      // title="Informations"
                      // description="Hi, I'm Alec Thompson, Decisions: If you can’t decide, the answer is no. If two equally difficult paths, choose the one more painful in the short term (pain avoidance is creating an illusion of equality)."
                      info={
                        {
                          // "Nom et prénom": "Alec M. Thompson",
                        }
                      }
                      social={[
                        {
                          link: "https://www.facebook.com/CreativeTim/",
                          icon: <FacebookIcon />,
                          color: "facebook",
                        },
                        {
                          link: "https://twitter.com/creativetim",
                          icon: <TwitterIcon />,
                          color: "twitter",
                        },
                        {
                          link: "https://www.instagram.com/creativetimofficial/",
                          icon: <InstagramIcon />,
                          color: "instagram",
                        },
                      ]}
                      action={{ route: "", tooltip: "Edit Profile" }}
                      shadow={false}
                    />
                    <Divider orientation="vertical" sx={{ mx: 0 }} />
                  </Grid>
                  <Grid item xs={12} md={6} xl={4} sx={{ display: "flex" }}>
                    <PlatformSettings2
                      eventStatiquesDetails={eventStatiquesDetails}
                      // categoryProgressionData={categoryProgressionData}
                      // fillRateData={categoryFillRateData}
                    />
                  </Grid>
                </Grid>
              </MDBox>
            </Header>

            <MDBox pt={3} pb={3} px={3}>
              <Grid container spacing={2} alignItems="center">
                {(eventDetails?.isCinema || eventDetails?.isCirque) && (
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={availableCinemaHours}
                      isOptionEqualToValue={(option, value) => option.generatedId === value.generatedId}
                      getOptionLabel={(option) => {
                        if (!option?.eventDate) {
                          return "";
                        }
                        else if(option?.eventDate === "all") {
                          return "Tous";
                        }
                        const date = new Date(option.eventDate);
                        return `${formatedDate(date)} ${formatedTime(date)}`;
                      }}
                      onChange={handleAutoCompleteCinemaHoursChange}
                      renderInput={(params) => <FormField {...params} label="Horaires" />}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  <MDBox display="flex" gap={1} flexWrap="wrap">
                    <MDButton
                      variant="contained"
                      color="success"
                      disabled={exportTicketsLoading}
                      onClick={handleExportTickets}
                    >
                      {exportTicketsLoading ? "Export..." : "Exporter les tickets"}
                    </MDButton>
                  </MDBox>
                </Grid>
                {/* fix tickets */}
                {/* <Grid item xs={12} sm={6}>
                  <MDBox display="flex" gap={1} flexWrap="wrap">
                    <MDButton
                      variant="outlined"
                      color="error"
                      onClick={() => setReduceDialogOpen(true)}
                    >
                      Réduire les tickets de cet horaire
                    </MDButton>
                    <MDButton
                      variant="contained"
                      color="error"
                      onClick={() => setDeleteBySiegeDialogOpen(true)}
                    >
                      Supprimer tickets par catégorie
                    </MDButton>
                    {(eventDetails?.isCinema || eventDetails?.isCirque) && (
                      <MDButton
                        variant="contained"
                        color="error"
                        onClick={() => setDeleteByTimeIdDialogOpen(true)}
                      >
                        Supprimer tickets par horaire
                      </MDButton>
                    )}
                    {(eventDetails?.isCinema || eventDetails?.isCirque) && (
                      <MDButton
                        variant="outlined"
                        color="error"
                        onClick={() => setDeleteNotInTimeIdDialogOpen(true)}
                      >
                        Supprimer tickets hors horaires valides
                      </MDButton>
                    )}
                    <MDButton
                      variant="outlined"
                      color="warning"
                      disabled={fixOrphanLoading}
                      onClick={handleFixOrphanedTickets}
                    >
                      {fixOrphanLoading ? "Correction..." : "Corriger tickets orphelins"}
                    </MDButton>
                  </MDBox>
                </Grid> */}
                {/* fix tickets */}
              </Grid>
            </MDBox>

            <MDBox mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  <DefaultStatisticsCard
                    title="Nombre de tickets vendus"
                    count={eventStatiquesDetails?.numberOfSellTickets}
                    percentage={{
                      color: "success",
                      value: "",
                      label: "",
                    }}
                    dropdown={{
                      action: openSalesDropdown,
                      menu: renderMenu(salesDropdown, closeSalesDropdown),
                      value: salesDropdownValue,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <DefaultStatisticsCard
                    title="Nombre d'invitations"
                    count={eventStatiquesDetails?.numberOfInvitation}
                    percentage={{
                      color: "success",
                      value: "",
                      label: "",
                    }}
                    dropdown={{
                      action: openSalesDropdown,
                      menu: renderMenu(salesDropdown, closeSalesDropdown),
                      value: salesDropdownValue,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <DefaultStatisticsCard
                    title="Nombre de réservations"
                    count={eventStatiquesDetails?.numberOfReservation}
                    percentage={{
                      color: "success",
                      value: "",
                      label: "",
                    }}
                    dropdown={{
                      action: openSalesDropdown,
                      menu: renderMenu(salesDropdown, closeSalesDropdown),
                      value: salesDropdownValue,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <DefaultStatisticsCard
                    title="Tickets disponibles"
                    count={eventStatiquesDetails?.availableTickets}
                    percentage={{
                      color: "success",
                      value: "",
                      label: "",
                    }}
                    dropdown={{
                      action: openSalesDropdown,
                      menu: renderMenu(salesDropdown, closeSalesDropdown),
                      value: salesDropdownValue,
                    }}
                  />

                </Grid>
                <Grid item xs={12} sm={4}>
                  <DefaultStatisticsCard
                    title="Total des tickets"
                    count={eventStatiquesDetails?.sumOfTickets}
                    percentage={{
                      color: "success",
                      value: "",
                      label: "",
                    }}
                    dropdown={{
                      action: openSalesDropdown,
                      menu: renderMenu(salesDropdown, closeSalesDropdown),
                      value: salesDropdownValue,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <DefaultStatisticsCard
                    title="Chiffre d'affaires"
                    count={`${eventStatiquesDetails?.turnOver} MAD`}
                    percentage={{
                      color: "success",
                      value: "",
                      label: "",
                    }}
                    dropdown={{
                      action: openSalesDropdown,
                      menu: renderMenu(salesDropdown, closeSalesDropdown),
                      value: salesDropdownValue,
                    }}
                  />
                </Grid>
              </Grid>
            </MDBox>
          </>
        }
        {
          (userRole === "SuperAdmin"  || userRole === "Producer") &&
          <Grid container spacing={3} mb={3}>
            <Grid item xs={12} sm={12}>
              <Card>
                <MDBox pt={3} px={3}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Les tickets
                  </MDTypography>
                </MDBox>
                <MDBox py={1}>
                  <Table aria-label="simple table">
                    <TableHead style={{ display: "table-header-group", important: "true" }}>
                      <TableRow>
                        <TableCell
                          align="left"
                          style={{
                            color: "#7b809a",
                            fontSize: "0.7rem",
                            opacity: "0.7",
                            textTransform: "uppercase",
                          }}
                        >
                          Siège
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{
                            color: "#7b809a",
                            fontSize: "0.7rem",
                            opacity: "0.7",
                            textTransform: "uppercase",
                          }}
                        >
                          Tickets vendus
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{
                            color: "#7b809a",
                            fontSize: "0.7rem",
                            opacity: "0.7",
                            textTransform: "uppercase",
                          }}
                        >
                          Invitations
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{
                            color: "#7b809a",
                            fontSize: "0.7rem",
                            opacity: "0.7",
                            textTransform: "uppercase",
                          }}
                        >
                          Tickets hors ligne
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{
                            color: "#7b809a",
                            fontSize: "0.7rem",
                            opacity: "0.7",
                            textTransform: "uppercase",
                          }}
                        >
                          Tickets en ligne
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{
                            color: "#7b809a",
                            fontSize: "0.7rem",
                            opacity: "0.7",
                            textTransform: "uppercase",
                          }}
                        >
                          Prix unitaire
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{
                            color: "#7b809a",
                            fontSize: "0.7rem",
                            opacity: "0.7",
                            textTransform: "uppercase",
                          }}
                        >
                          Prix total (Online)
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{
                            color: "#7b809a",
                            fontSize: "0.7rem",
                            opacity: "0.7",
                            textTransform: "uppercase",
                          }}
                        >
                          Prix total (Offline)
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{
                            color: "#7b809a",
                            fontSize: "0.7rem",
                            opacity: "0.7",
                            textTransform: "uppercase",
                          }}
                        >
                          Prix total
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {isLoading || !eventStatiquesDetails?.eventCategoriesDetails ? (
                      <MDBox>
                        <CircularProgress size={80} color="info"></CircularProgress>
                      </MDBox>
                    ) : (
                      <TableBody>
                        {Object.entries(eventStatiquesDetails?.eventCategoriesDetails || {}).map(
                          ([key, value]) => {
                            return (
                              <TableRow
                                key="index"
                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                              >
                                <TableCell
                                  align="left"
                                  style={{
                                    color: "#7b809a",
                                    fontSize: "0.8rem",
                                    fontWeight: "600",
                                    maxWidth: 100,
                                  }}
                                >
                                  <p>{key === "sumOfValues" ? "Total" : key}</p>
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{
                                    color: "#7b809a",
                                    fontSize: "0.8rem",
                                    fontWeight: "600",
                                    maxWidth: 100,
                                  }}
                                >
                                  <p>{value.numberOfSellTickets}</p>
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{
                                    color: "#7b809a",
                                    fontSize: "0.8rem",
                                    fontWeight: "600",
                                    maxWidth: 100,
                                  }}
                                >
                                  <p>{value.numberOfInvitation}</p>
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{
                                    color: "#7b809a",
                                    fontSize: "0.8rem",
                                    fontWeight: "600",
                                    maxWidth: 100,
                                  }}
                                >
                                  <p>{value.offlineTickets}</p>
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{
                                    color: "#7b809a",
                                    fontSize: "0.8rem",
                                    fontWeight: "600",
                                    maxWidth: 100,
                                  }}
                                >
                                  <p>{value.onlineTickets}</p>
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{
                                    color: "#7b809a",
                                    fontSize: "0.8rem",
                                    fontWeight: "600",
                                    maxWidth: 100,
                                  }}
                                >
                                  <p>{value.unityPrice}</p>
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{
                                    color: "#7b809a",
                                    fontSize: "0.8rem",
                                    fontWeight: "600",
                                    maxWidth: 100,
                                  }}
                                >
                                  <p>{value.calculatedCategoryTurnOverOnline} MAD</p>
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{
                                    color: "#7b809a",
                                    fontSize: "0.8rem",
                                    fontWeight: "600",
                                    maxWidth: 100,
                                  }}
                                >
                                  <p>{value.calculatedCategoryTurnOverOffline} MAD</p>
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{
                                    color: "#7b809a",
                                    fontSize: "0.8rem",
                                    fontWeight: "600",
                                    maxWidth: 100,
                                  }}
                                >
                                  <p>{value.calculatedCategoryTurnOver} MAD</p>
                                </TableCell>
                              </TableRow>
                            );
                          }
                        )}
                      </TableBody>
                    )}
                  </Table>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        }

        <Grid container spacing={3} mb={3}>
          {
            (userRole === "SuperAdmin"  || userRole === "Producer") &&
            <Grid item xs={12}>
              {/* Make this take full width */}
              <Card>
                {/* Existing Card */}
                <MDBox pt={3} px={3}>
                  {/* Existing Box for heading */}
                  <MDTypography variant="h6" fontWeight="medium">
                    Détails par Catégorie {/* Updated heading */}
                  </MDTypography>
                </MDBox>
                <MDBox py={1}>
                  {/* Box for the table */}
                  {/* Show loading indicator if data is loading OR if the new data states are null */}
                  {isLoading || !categoryProgressionData || !categoryFillRateData ? (
                    <MDBox
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      minHeight="200px"
                    >
                      {/* Styling for centering spinner */}
                      <CircularProgress size={40} color="info" />
                      <MDTypography variant="body2" color="text" ml={2}>
                        Loading detailed statistics... {/* Loading message */}
                      </MDTypography>
                    </MDBox>
                  ) : (
                    // Show the table if both categoryProgressionData and categoryFillRateData are loaded
                    <Table aria-label="category statistics table">
                      {/* Table Header */}
                      <TableHead style={{ display: "table-header-group" }}>
                        <TableRow>
                          {/* Column for Category Name */}
                          <TableCell
                            align="left"
                            style={{
                              color: "#7b809a",
                              fontSize: "0.7rem",
                              opacity: "0.7",
                              textTransform: "uppercase",
                            }}
                          >
                            Siège
                          </TableCell>
                          {/* Columns for Progression */}
                          <TableCell
                            align="left"
                            style={{
                              color: "#7b809a",
                              fontSize: "0.7rem",
                              opacity: "0.7",
                              textTransform: "uppercase",
                            }}
                          >
                            Tickets vendus
                          </TableCell>
                          <TableCell
                            align="left"
                            style={{
                              color: "#7b809a",
                              fontSize: "0.7rem",
                              opacity: "0.7",
                              textTransform: "uppercase",
                            }}
                          >
                            Progression %
                          </TableCell>
                          {/* Columns for Fill Rate */}
                          <TableCell
                            align="left"
                            style={{
                              color: "#7b809a",
                              fontSize: "0.7rem",
                              opacity: "0.7",
                              textTransform: "uppercase",
                            }}
                          >
                            Taux de Remplissage (Utilisé/Émis)
                          </TableCell>
                          <TableCell
                            align="left"
                            style={{
                              color: "#7b809a",
                              fontSize: "0.7rem",
                              opacity: "0.7",
                              textTransform: "uppercase",
                            }}
                          >
                            Taux de Remplissage %
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      {/* Table Body */}
                      <TableBody>
                        {categoryProgressionData.map((progressionCat) => {
                          const fillRateCat = categoryFillRateData.find(
                            (fillCat) => fillCat.name === progressionCat.name
                          );

                          const used = fillRateCat?.used || 0;
                          const issued = fillRateCat?.issued || 0;
                          const fillRatePercentage = fillRateCat?.percentage || 0;

                          return (
                            <TableRow
                              key={progressionCat.name} // Use category name as a unique key for the row
                              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                            >
                              {/* Cell for Category Name */}
                              <TableCell
                                align="left"
                                style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "600" }}
                              >
                                {progressionCat.name} {/* Display category name */}
                              </TableCell>
                              {/* Cells for Progression */}
                              <TableCell
                                align="left"
                                style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "600" }}
                              >
                                {progressionCat.sold}/{progressionCat.total}
                                {/* Display Sold/Total */}
                              </TableCell>
                              <TableCell
                                align="left"
                                style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "600" }}
                              >
                                {progressionCat.percentage}% {/* Display Progression Percentage */}
                              </TableCell>
                              {/* Cells for Fill Rate */}
                              <TableCell
                                align="left"
                                style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "600" }}
                              >
                                {used}/{issued} {/* Display Used/Issued */}
                              </TableCell>
                              <TableCell
                                align="left"
                                style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "600" }}
                              >
                                {fillRatePercentage}%{/* Display Fill Rate Percentage */}
                              </TableCell>
                              {/* Add more TableCell elements here for additional columns defined in TableHead */}
                            </TableRow>
                          );
                        })}
                        {categoryProgressionData && categoryFillRateData && (
                          <TableRow
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                              fontWeight: "bold",
                            }}
                          >
                            <TableCell
                              align="left"
                              style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "bold" }}
                            >
                              Total
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "bold" }}
                            >
                              {totalCategorySold}/{totalCategoryCapacity}
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "bold" }}
                            >
                              {totalCategoryProgression}%
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "bold" }}
                            >
                              {totalUsedTickets}/{totalIssuedTickets}
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "bold" }}
                            >
                              {totalFillRatePercentage}%
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  )}
                </MDBox>
              </Card>
            </Grid>
          }

          {
            otherRolesDetails?.producerId && userRole === "SuperAdmin" &&
            <Grid item xs={12}>
              {/* Make this take full width */}
              <Card mt={2}>
                {/* Existing Card */}
                <MDBox pt={3} px={3}>
                  {/* Existing Box for heading */}
                  <MDTypography variant="h6" fontWeight="medium">
                    {/* Détails par Catégorie - 1 producteur de cet événements */}
                    Détails par Catégorie - admin
                  </MDTypography>
                </MDBox>

                <MDBox py={1}>
                  {/* Box for the table */}
                  {/* Show loading indicator if data is loading OR if the new data states are null */}
                  {isLoading || !categoryProgressionData || !categoryFillRateData ? (
                    <MDBox
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      minHeight="200px"
                    >
                      {/* Styling for centering spinner */}
                      <CircularProgress size={40} color="info" />
                      <MDTypography variant="body2" color="text" ml={2}>
                        Loading detailed statistics... {/* Loading message */}
                      </MDTypography>
                    </MDBox>
                  ) : (
                    // Show the table if both categoryProgressionData and categoryFillRateData are loaded
                    <MDBox>
                      <Table aria-label="category statistics table">
                        {/* Table Header */}
                        <TableHead style={{ display: "table-header-group" }}>
                          <TableRow>
                            {/* Column for Category Name */}
                            <TableCell
                              align="left"
                              style={{
                                color: "#7b809a",
                                fontSize: "0.7rem",
                                opacity: "0.7",
                                textTransform: "uppercase",
                              }}
                            >
                              Siège
                            </TableCell>
                            {/* Columns for Progression */}
                            <TableCell
                              align="left"
                              style={{
                                color: "#7b809a",
                                fontSize: "0.7rem",
                                opacity: "0.7",
                                textTransform: "uppercase",
                              }}
                            >
                              Tickets vendus
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{
                                color: "#7b809a",
                                fontSize: "0.7rem",
                                opacity: "0.7",
                                textTransform: "uppercase",
                              }}
                            >
                              Invitations
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{
                                color: "#7b809a",
                                fontSize: "0.7rem",
                                opacity: "0.7",
                                textTransform: "uppercase",
                              }}
                            >
                              Chiffre d'affaires
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        {/* Table Body */}
                        <TableBody>
                          {adminCategoryProgressionData?.tableData?.map((progressionCat) => {
                            const fillRateCat = categoryFillRateData.find(
                              (fillCat) => fillCat.name === progressionCat.name
                            );

                            const used = fillRateCat?.used || 0;
                            const issued = fillRateCat?.issued || 0;
                            const fillRatePercentage = fillRateCat?.percentage || 0;

                            return (
                              <TableRow
                                key={progressionCat.name} // Use category name as a unique key for the row
                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                              >
                                {/* Cell for Category Name */}
                                <TableCell
                                  align="left"
                                  style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "600" }}
                                >
                                  {progressionCat.name} {/* Display category name */}
                                </TableCell>
                                {/* Cells for Progression */}
                                <TableCell
                                  align="left"
                                  style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "600" }}
                                >
                                  {/* {progressionCat.sold}/{progressionCat.total} */}
                                  {progressionCat.sold}
                                  {/* Display Sold/Total */}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "600" }}
                                >
                                  {progressionCat.invitation} {/* Display Progression Percentage */}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "600" }}
                                >
                                  {progressionCat.sumOfPrices} MAD {/* Display Progression Percentage */}
                                </TableCell>
                                {/* Add more TableCell elements here for additional columns defined in TableHead */}
                              </TableRow>
                            );
                          })}
                          {adminCategoryProgressionData?.sumOfData && (
                            <TableRow
                              sx={{
                                "&:last-child td, &:last-child th": { border: 0 },
                                fontWeight: "bold",
                              }}
                            >
                              <TableCell
                                align="left"
                                style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "bold" }}
                              >
                                Total
                              </TableCell>
                              <TableCell
                                align="left"
                                style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "bold" }}
                              >
                                {adminCategoryProgressionData?.sumOfData?.sumOfTickets}
                              </TableCell>
                              <TableCell
                                align="left"
                                style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "bold" }}
                              >
                                {adminCategoryProgressionData?.sumOfData?.sumOfInvitation}
                              </TableCell>
                              <TableCell
                                align="left"
                                style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "bold" }}
                              >
                                {adminCategoryProgressionData?.sumOfData?.sumOfPrices} MAD
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </MDBox>
                  )}
                </MDBox>
              </Card>
            </Grid>
          }

          {
            otherRolesDetails?.producerId && (userRole === "SuperAdmin" || userRole === "Producer") &&
            <Grid item xs={12}>
              {/* Make this take full width */}
              <Card mt={2}>
                {/* Existing Card */}
                <MDBox pt={3} px={3}>
                  {/* Existing Box for heading */}
                  <MDTypography variant="h6" fontWeight="medium">
                    {/* Détails par Catégorie - 1 producteur de cet événements */}
                    Détails par Catégorie - producteur
                  </MDTypography>
                </MDBox>

                <MDBox py={1}>
                  <MDTypography variant="h6" fontWeight="medium" px={3}>
                    { otherRolesDetails?.producerFullName }
                  </MDTypography>
                  {/* Box for the table */}
                  {/* Show loading indicator if data is loading OR if the new data states are null */}
                  {isLoading || !categoryProgressionData || !categoryFillRateData ? (
                    <MDBox
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      minHeight="200px"
                    >
                      {/* Styling for centering spinner */}
                      <CircularProgress size={40} color="info" />
                      <MDTypography variant="body2" color="text" ml={2}>
                        Loading detailed statistics... {/* Loading message */}
                      </MDTypography>
                    </MDBox>
                  ) : (
                    // Show the table if both categoryProgressionData and categoryFillRateData are loaded
                    <MDBox>
                      <Table aria-label="category statistics table">
                        {/* Table Header */}
                        <TableHead style={{ display: "table-header-group" }}>
                          <TableRow>
                            {/* Column for Category Name */}
                            <TableCell
                              align="left"
                              style={{
                                color: "#7b809a",
                                fontSize: "0.7rem",
                                opacity: "0.7",
                                textTransform: "uppercase",
                              }}
                            >
                              Siège
                            </TableCell>
                            {/* Columns for Progression */}
                            <TableCell
                              align="left"
                              style={{
                                color: "#7b809a",
                                fontSize: "0.7rem",
                                opacity: "0.7",
                                textTransform: "uppercase",
                              }}
                            >
                              Tickets vendus
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{
                                color: "#7b809a",
                                fontSize: "0.7rem",
                                opacity: "0.7",
                                textTransform: "uppercase",
                              }}
                            >
                              Invitations
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{
                                color: "#7b809a",
                                fontSize: "0.7rem",
                                opacity: "0.7",
                                textTransform: "uppercase",
                              }}
                            >
                              Chiffre d'affaires
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        {/* Table Body */}
                        <TableBody>
                          {producerCategoryProgressionData?.tableData?.map((progressionCat) => {
                            const fillRateCat = categoryFillRateData.find(
                              (fillCat) => fillCat.name === progressionCat.name
                            );

                            const used = fillRateCat?.used || 0;
                            const issued = fillRateCat?.issued || 0;
                            const fillRatePercentage = fillRateCat?.percentage || 0;

                            return (
                              <TableRow
                                key={progressionCat.name} // Use category name as a unique key for the row
                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                              >
                                {/* Cell for Category Name */}
                                <TableCell
                                  align="left"
                                  style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "600" }}
                                >
                                  {progressionCat.name} {/* Display category name */}
                                </TableCell>
                                {/* Cells for Progression */}
                                <TableCell
                                  align="left"
                                  style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "600" }}
                                >
                                  {/* {progressionCat.sold}/{progressionCat.total} */}
                                  {progressionCat.sold}
                                  {/* Display Sold/Total */}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "600" }}
                                >
                                  {progressionCat.invitation} {/* Display Progression Percentage */}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "600" }}
                                >
                                  {progressionCat.sumOfPrices} MAD {/* Display Progression Percentage */}
                                </TableCell>
                                {/* Add more TableCell elements here for additional columns defined in TableHead */}
                              </TableRow>
                            );
                          })}
                          {producerCategoryProgressionData?.sumOfData && (
                            <TableRow
                              sx={{
                                "&:last-child td, &:last-child th": { border: 0 },
                                fontWeight: "bold",
                              }}
                            >
                              <TableCell
                                align="left"
                                style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "bold" }}
                              >
                                Total
                              </TableCell>
                              <TableCell
                                align="left"
                                style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "bold" }}
                              >
                                {producerCategoryProgressionData?.sumOfData?.sumOfTickets}
                              </TableCell>
                              <TableCell
                                align="left"
                                style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "bold" }}
                              >
                                {producerCategoryProgressionData?.sumOfData?.sumOfInvitation}
                              </TableCell>
                              <TableCell
                                align="left"
                                style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "bold" }}
                              >
                                {producerCategoryProgressionData?.sumOfData?.sumOfPrices} MAD
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </MDBox>
                  )}
                </MDBox>
              </Card>
            </Grid>
          }

          {
            (otherRolesDetails?.producerId && resellerCategoryProgressionData?.tableData?.length !== 0) &&
            <Grid item xs={12}>
              {/* Make this take full width */}
              <Card mt={2}>
                {/* Existing Card */}
                <MDBox pt={3} px={3}>
                  {/* Existing Box for heading */}
                  <MDTypography variant="h6" fontWeight="medium">
                    {/* Détails par Catégorie - 1 producteur de cet événements */}
                    Détails par Catégorie - { resellerCategoryProgressionData?.tableData?.length } revendeurs de cet événements
                  </MDTypography>
                </MDBox>

                {
                  resellerCategoryProgressionData?.tableData.map(resellerData => {
                    return (
                      <MDBox py={1}>
                        <MDTypography variant="h6" fontWeight="medium" px={3}>
                          { resellerData.firstName } { resellerData.lastName }
                        </MDTypography>
                        {/* Box for the table */}
                        {/* Show loading indicator if data is loading OR if the new data states are null */}
                        {isLoading || !categoryProgressionData || !categoryFillRateData ? (
                          <MDBox
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            minHeight="200px"
                          >
                            {/* Styling for centering spinner */}
                            <CircularProgress size={40} color="info" />
                            <MDTypography variant="body2" color="text" ml={2}>
                              Loading detailed statistics... {/* Loading message */}
                            </MDTypography>
                          </MDBox>
                        ) : (
                          // Show the table if both categoryProgressionData and categoryFillRateData are loaded
                          <MDBox>
                            <Table aria-label="category statistics table">
                              {/* Table Header */}
                              <TableHead style={{ display: "table-header-group" }}>
                                <TableRow>
                                  {/* Column for Category Name */}
                                  <TableCell
                                    align="left"
                                    style={{
                                      color: "#7b809a",
                                      fontSize: "0.7rem",
                                      opacity: "0.7",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    Siège
                                  </TableCell>
                                  {/* Columns for Progression */}
                                  <TableCell
                                    align="left"
                                    style={{
                                      color: "#7b809a",
                                      fontSize: "0.7rem",
                                      opacity: "0.7",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    Tickets vendus
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    style={{
                                      color: "#7b809a",
                                      fontSize: "0.7rem",
                                      opacity: "0.7",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    Chiffre d'affaires
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              {/* Table Body */}
                              <TableBody>
                                {resellerData?.resellerTableData?.map((progressionCat) => {
                                  const fillRateCat = categoryFillRateData.find(
                                    (fillCat) => fillCat.name === progressionCat.name
                                  );

                                  const used = fillRateCat?.used || 0;
                                  const issued = fillRateCat?.issued || 0;
                                  const fillRatePercentage = fillRateCat?.percentage || 0;

                                  return (
                                    <TableRow
                                      key={progressionCat.name} // Use category name as a unique key for the row
                                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                    >
                                      {/* Cell for Category Name */}
                                      <TableCell
                                        align="left"
                                        style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "600" }}
                                      >
                                        {progressionCat.name} {/* Display category name */}
                                      </TableCell>
                                      {/* Cells for Progression */}
                                      <TableCell
                                        align="left"
                                        style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "600" }}
                                      >
                                        {/* {progressionCat.sold}/{progressionCat.total} */}
                                        {progressionCat.sold}
                                        {/* Display Sold/Total */}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "600" }}
                                      >
                                        {progressionCat.sumOfPrices} MAD
                                      </TableCell>
                                      {/* Add more TableCell elements here for additional columns defined in TableHead */}
                                    </TableRow>
                                  );
                                })}

                                  <TableRow
                                    sx={{
                                      "&:last-child td, &:last-child th": { border: 0 },
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <TableCell
                                      align="left"
                                      style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "bold" }}
                                    >
                                      Total
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "bold" }}
                                    >
                                      {resellerData?.totalTickets}
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "bold" }}
                                    >
                                      {resellerData?.sumOfRPrices} MAD
                                    </TableCell>
                                  </TableRow>
                                
                              </TableBody>
                            </Table>
                          </MDBox>
                        )}
                      </MDBox>
                    )
                  })
                }

              </Card>
            </Grid>
          }
        </Grid>

        {/* <Grid container spacing={3} mb={3}>
          <Grid item xs={12} sm={12}>
            <Card>
              <MDBox pt={3} px={3}>
                <MDTypography variant="h6" fontWeight="medium">
                  Revendeurs
                </MDTypography>
              </MDBox>
              <MDBox py={1}>
                <DataTable
                  table={dataTableData2}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  isSorted={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid> */}
      </MDBox>
      <Footer />

      <Dialog
        open={reduceDialogOpen}
        onClose={() => { setReduceDialogOpen(false); setReduceByValue(""); setSelectedReduceCategory(""); }}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Réduire les tickets disponibles</DialogTitle>
        <DialogContent>
          <MDBox mb={2} mt={1}>
            <MDTypography variant="body2" color="text">
              Tickets disponibles actuels :{" "}
              <strong>{eventStatiquesDetails?.availableTickets ?? "—"}</strong>
            </MDTypography>
            <MDTypography variant="caption" color="warning">
              Seuls les tickets avec transactionIsComplet = false seront supprimés.
            </MDTypography>
          </MDBox>
          <FormControl fullWidth variant="outlined" sx={{ mb: 2 }}>
            <InputLabel>Catégorie</InputLabel>
            <Select
              label="Catégorie"
              value={selectedReduceCategory}
              onChange={(e) => setSelectedReduceCategory(e.target.value)}
            >
              {(categoryProgressionData ?? []).map((cat) => (
                <MenuItem key={cat.id} value={cat.id}>
                  {cat.name} — {(cat.total ?? 0) - (cat.sold ?? 0)} disponibles
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <MDBox display="flex" gap={1} mb={2}>
            <TextField
              label="Nombre à supprimer"
              type="number"
              fullWidth
              variant="outlined"
              value={reduceByValue}
              onChange={(e) => setReduceByValue(e.target.value)}
              inputProps={{ min: 1 }}
            />
            <MDButton
              variant="outlined"
              color="error"
              onClick={handleReduceAllTickets}
              disabled={reduceLoading || !selectedReduceCategory}
              sx={{ whiteSpace: "nowrap", minWidth: "fit-content" }}
            >
              Supprimer tout
            </MDButton>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => { setReduceDialogOpen(false); setReduceByValue(""); setSelectedReduceCategory(""); }} color="secondary">
            Annuler
          </MDButton>
          <MDButton
            onClick={handleReduceAvailableTickets}
            color="error"
            disabled={reduceLoading || !reduceByValue || parseInt(reduceByValue) < 1 || !selectedReduceCategory}
          >
            {reduceLoading ? "Suppression..." : "Supprimer"}
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={deleteBySiegeDialogOpen}
        onClose={() => { setDeleteBySiegeDialogOpen(false); setDeleteBySiegeCategory(""); }}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Supprimer tickets par catégorie</DialogTitle>
        <DialogContent>
          <MDBox mb={2} mt={1}>
            <MDTypography variant="caption" color="warning">
              Seuls les tickets avec transactionIsComplet = false seront supprimés.
            </MDTypography>
          </MDBox>
          <TextField
            label="ticketSiegeId"
            placeholder="ex: 4e9cd508-df64-4a3d-a706-2b86152d581a"
            fullWidth
            variant="outlined"
            value={deleteBySiegeCategory}
            onChange={(e) => setDeleteBySiegeCategory(e.target.value.trim())}
          />
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => { setDeleteBySiegeDialogOpen(false); setDeleteBySiegeCategory(""); }}
            color="secondary"
          >
            Annuler
          </MDButton>
          <MDButton
            onClick={handleDeleteTicketsBySiege}
            color="error"
            disabled={deleteBySiegeLoading || !deleteBySiegeCategory}
          >
            {deleteBySiegeLoading ? "Suppression..." : "Supprimer"}
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteByTimeIdDialogOpen}
        onClose={() => { setDeleteByTimeIdDialogOpen(false); setDeleteByTimeIdList([]); setDeleteByTimeIdInput(""); }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Supprimer tickets par horaire</DialogTitle>
        <DialogContent>
          <MDBox mb={2} mt={1}>
            <MDTypography variant="caption" color="warning">
              Tous les tickets vendus (transactionIsComplet = true) pour les horaires listés seront supprimés définitivement.
            </MDTypography>
          </MDBox>
          <MDBox display="flex" gap={1} mb={1}>
            <TextField
              label="selectedTimeId"
              placeholder="ex: 4e9cd508-df64-4a3d-a706-2b86152d581a"
              fullWidth
              variant="outlined"
              value={deleteByTimeIdInput}
              onChange={(e) => setDeleteByTimeIdInput(e.target.value.trim())}
              onKeyDown={(e) => {
                if (e.key === "Enter" && deleteByTimeIdInput && !deleteByTimeIdList.includes(deleteByTimeIdInput)) {
                  setDeleteByTimeIdList((prev) => [...prev, deleteByTimeIdInput]);
                  setDeleteByTimeIdInput("");
                }
              }}
            />
            <MDButton
              variant="outlined"
              color="info"
              onClick={() => {
                if (deleteByTimeIdInput && !deleteByTimeIdList.includes(deleteByTimeIdInput)) {
                  setDeleteByTimeIdList((prev) => [...prev, deleteByTimeIdInput]);
                  setDeleteByTimeIdInput("");
                }
              }}
              disabled={!deleteByTimeIdInput}
              sx={{ whiteSpace: "nowrap" }}
            >
              Ajouter
            </MDButton>
          </MDBox>
          {deleteByTimeIdList.length > 0 && (
            <MDBox display="flex" flexWrap="wrap" gap={1} mt={1}>
              {deleteByTimeIdList.map((id, i) => (
                <MDBox
                  key={i}
                  display="flex"
                  alignItems="center"
                  gap={0.5}
                  px={1}
                  py={0.5}
                  sx={{ background: "#f5f5f5", borderRadius: "4px", fontSize: "0.75rem", fontFamily: "monospace" }}
                >
                  {id}
                  <Icon
                    fontSize="small"
                    style={{ cursor: "pointer", color: "#d33" }}
                    onClick={() => setDeleteByTimeIdList((prev) => prev.filter((_, j) => j !== i))}
                  >
                    close
                  </Icon>
                </MDBox>
              ))}
            </MDBox>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => { setDeleteByTimeIdDialogOpen(false); setDeleteByTimeIdList([]); setDeleteByTimeIdInput(""); }}
            color="secondary"
          >
            Annuler
          </MDButton>
          <MDButton
            onClick={handleDeleteTicketsByTimeId}
            color="error"
            disabled={deleteByTimeIdLoading || deleteByTimeIdList.length === 0}
          >
            {deleteByTimeIdLoading ? "Suppression..." : `Supprimer (${deleteByTimeIdList.length})`}
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteNotInTimeIdDialogOpen}
        onClose={() => { setDeleteNotInTimeIdDialogOpen(false); setDeleteNotInTimeIdList([]); setDeleteNotInTimeIdInput(""); }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Supprimer tickets hors horaires valides</DialogTitle>
        <DialogContent>
          <MDBox mb={2} mt={1}>
            <MDTypography variant="caption" color="warning">
              Entrez les selectedTimeId <strong>valides à conserver</strong>. Tous les tickets dont le selectedTimeId n&apos;est PAS dans cette liste seront supprimés.
            </MDTypography>
          </MDBox>
          <MDBox display="flex" gap={1} mb={1}>
            <TextField
              label="selectedTimeId valide"
              placeholder="ex: c7d998f1-ff5e-42f3-99f8-b96328622e95"
              fullWidth
              variant="outlined"
              value={deleteNotInTimeIdInput}
              onChange={(e) => setDeleteNotInTimeIdInput(e.target.value.trim())}
              onKeyDown={(e) => {
                if (e.key === "Enter" && deleteNotInTimeIdInput && !deleteNotInTimeIdList.includes(deleteNotInTimeIdInput)) {
                  setDeleteNotInTimeIdList((prev) => [...prev, deleteNotInTimeIdInput]);
                  setDeleteNotInTimeIdInput("");
                }
              }}
            />
            <MDButton
              variant="outlined"
              color="info"
              onClick={() => {
                if (deleteNotInTimeIdInput && !deleteNotInTimeIdList.includes(deleteNotInTimeIdInput)) {
                  setDeleteNotInTimeIdList((prev) => [...prev, deleteNotInTimeIdInput]);
                  setDeleteNotInTimeIdInput("");
                }
              }}
              disabled={!deleteNotInTimeIdInput}
              sx={{ whiteSpace: "nowrap" }}
            >
              Ajouter
            </MDButton>
          </MDBox>
          {deleteNotInTimeIdList.length > 0 && (
            <MDBox display="flex" flexWrap="wrap" gap={1} mt={1}>
              {deleteNotInTimeIdList.map((id, i) => (
                <MDBox
                  key={i}
                  display="flex"
                  alignItems="center"
                  gap={0.5}
                  px={1}
                  py={0.5}
                  sx={{ background: "#e8f5e9", borderRadius: "4px", fontSize: "0.75rem", fontFamily: "monospace" }}
                >
                  {id}
                  <Icon
                    fontSize="small"
                    style={{ cursor: "pointer", color: "#d33" }}
                    onClick={() => setDeleteNotInTimeIdList((prev) => prev.filter((_, j) => j !== i))}
                  >
                    close
                  </Icon>
                </MDBox>
              ))}
            </MDBox>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => { setDeleteNotInTimeIdDialogOpen(false); setDeleteNotInTimeIdList([]); setDeleteNotInTimeIdInput(""); }}
            color="secondary"
          >
            Annuler
          </MDButton>
          <MDButton
            onClick={handleDeleteTicketsNotInTimeIds}
            color="error"
            disabled={deleteNotInTimeIdLoading || deleteNotInTimeIdList.length === 0}
          >
            {deleteNotInTimeIdLoading ? "Suppression..." : `Supprimer hors liste (${deleteNotInTimeIdList.length} valides)`}
          </MDButton>
        </DialogActions>
      </Dialog>

    </DashboardLayout>
  );
}

export default EventsDetails;
